// ** Routes Imports
import DashboardRoutes from './routes/DashboardRoutes';
import LoginRoutes from './routes/LoginRoutes';
import LeaguesRoutes from './routes/LeaguesRoutes';
import RefereeRoutes from './routes/RefereeRoutes';

// ** Default Route
const DefaultRoute = '/home';

// ** Merge Routes
const RouteList = [
  ...LoginRoutes,
  ...DashboardRoutes,
  ...LeaguesRoutes,
  ...RefereeRoutes,
];

export { DefaultRoute, RouteList };
